import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import io from 'socket.io-client';

import CardStatusRealTime from './CardStatus';

import chatIcon from '../../../../../assets/images/chat.svg';
import callCenterIcon from '../../../../../assets/images/callcenter.svg';
import robotIcon from '../../../../../assets/images/robot.svg';

import './style.scss';

export default function StatusRealTime() {
  const { botid: botId } = useParams();
  const socketUrl = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3335';

  const [sessionActive, setSessionActive] = useState(0);
  const [justBot, setJustBot] = useState(0);
  const [humanService, setHumanService] = useState(0);

  useEffect(() => {
    const socket = io(socketUrl);

    setInterval(() => {
      socket.emit('get-current-bot-stats', botId);
    }, 1000);

    socket.on('current-bot-stats-response', (response) => {
      const totalSessions =
        response.humanSessionCount + response.noHumanSessionCount;

      setSessionActive(totalSessions);
      setJustBot(response.noHumanSessionCount);
      setHumanService(response.humanSessionCount);
    });

    return () => socket.disconnect();
  }, []);

  return (
    <div className="col-md-12 container-realtime">
      <CardStatusRealTime
        icon={chatIcon}
        title="Sessões Ativas"
        value={sessionActive}
        color="#F59B10"
      />
      <CardStatusRealTime
        icon={robotIcon}
        styleIcon={{
          filter:
            'invert(48%) sepia(43%) saturate(4428%) hue-rotate(333deg) brightness(106%) contrast(88%)',
        }}
        title="Apenas Bot"
        value={justBot}
        color="#f15f52"
      />
      <CardStatusRealTime
        icon={callCenterIcon}
        styleIcon={{
          filter:
            'invert(52%) sepia(100%) saturate(363%) hue-rotate(102deg) brightness(101%) contrast(97%)',
        }}
        title="Atendimento Humano"
        value={humanService}
        color="#15CE7E"
      />
    </div>
  );
}
